export class ShowItemService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(params) {
    return await this.httpClient.get('/itens/Detalhes', { params })
  }
}
